// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NsXT","question":"styles_question__4agSl","inputVisibleButton":"styles_inputVisibleButton__3JOkt","note":"styles_note__2TAyG"};